import { Logger } from "../../dependencies/logger";

const logger = new Logger(
  "RESTAURANT_STORE - FIREBASE - SUBSCRIPTION_MANAGER",
  "LOG",
);
// logger.enable();

export default logger;

export const VERBOSE = false;
